import React, { useState, useEffect } from "react";
import { Button, Modal, Card, Container, Row, Col, Form, Spinner } from "react-bootstrap";
import { FaEye, FaFilePdf } from "react-icons/fa";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import { failureAlert, successAlert2 } from "../CommonUtils/SweetAlerts";
import { useFormik, FormikProvider, ErrorMessage } from "formik";
import * as Yup from "yup";
import { viewImage } from "../CommonUtils/viewImage";
import { ImagePdfBucket } from "../CommonUtils/ImagesBase64";
import VerificationChecklistTable from "./VerificationChecklistTable";

export default function StudentFormReceiving({ fetchStudents, selectedStudent, setShowCheckModal, setSubmitting }) {
  const login = localStorage.getItem("user_id");
  // const [showCheckModal, setShowCheckModal] = useState(false);
  // const [selectedStudent, setSelectedStudent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [students, setStudents] = useState([]);
  // const [submitting, setSubmitting] = useState(false);
  const [disableflag, setDisableFlag] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  // Particulars List
  const particularsList = [
    { sno: 1, particular: "Vacancy Available", asPerNorms: "Yes/No", fieldName: "vacancyAvailable", remarksField: "vacancyAvailableRemarks" },
    { sno: 2, particular: "Same Branch/Course", asPerNorms: "Yes/No", fieldName: "sameBranch", remarksField: "sameBranchRemarks" },
    { sno: 3, particular: "Intake Norms", asPerNorms: "Yes/No", fieldName: "inTakeNorms", remarksField: "inTakeNormsRemarks" },
    { sno: 4, particular: "University Compatibility", asPerNorms: "Yes/No", fieldName: "universityCompatability", remarksField: "universityCompatabilityRemarks" },
    // { sno: 5, particular: "Detention History", asPerNorms: "Yes/No", fieldName: "detentionHistory", remarksField: "detentionHistoryRemarks", },
  ];
  const handleViewPdf = async () => {
    if (!selectedStudent?.student_reg_no && !selectedStudent?.application_no) return;

    const studentId = selectedStudent?.student_reg_no || selectedStudent?.application_no;
    const nocStatus = selectedStudent?.noc_status || "";
    setPdfLoading(true);
    try {
      //   const url = `${config.url.STU_URL}generate/${studentId}/toCollege`;
      let url;
      if (nocStatus === "Approved") {
        url = `${config.url.STU_URL}generate/${studentId}/toCollege`;
      } else if (nocStatus === "Rejected") {
        url = `${config.url.STU_URL}generaterejection/${studentId}/toCollege`;
      }
      const response = await CommonAxiosPost(url);

      if (response?.data?.status === true || response?.data?.scode === "01") {
        const base64Pdf = response?.data?.pdfBase64;
        if (base64Pdf) {
          const pdfWindow = window.open();
          pdfWindow.document.write(`
                    <iframe src="data:application/pdf;base64,${base64Pdf}" 
                            width="100%" height="100%" style="border:none;"></iframe>
                `);
        } else {
          failureAlert("No PDF data found");
        }
      } else {
        failureAlert(response?.data?.message || "Failed to generate PDF");
      }
    } catch (error) {
      console.error("Error fetching PDF:", error);
      failureAlert("Error generating PDF");
    } finally {
      setPdfLoading(false);
    }
  };
  const formik = useFormik({
    initialValues: {
      vacancyAvailable: "",
      vacancyAvailableRemarks: "",
      sameBranch: "",
      sameBranchRemarks: "",
      inTakeNorms: "",
      inTakeNormsRemarks: "",
      universityCompatability: "",
      universityCompatabilityRemarks: "",
      detentionHistory: "",
      detentionHistoryRemarks: "",
      decision: "",
      nocApprovalLetter: "",
      remarks: "",
    },

    validationSchema: Yup.object({
      vacancyAvailable: Yup.string().required("Required"),
      vacancyAvailableRemarks: Yup.string().required("Required"),

      sameBranch: Yup.string().required("Required"),
      sameBranchRemarks: Yup.string().required("Required"),

      inTakeNorms: Yup.string().required("Required"),
      inTakeNormsRemarks: Yup.string().required("Required"),

      universityCompatability: Yup.string().required("Required"),
      universityCompatabilityRemarks: Yup.string().required("Required"),

      // detentionHistory: Yup.string().required("Required"),
      // detentionHistoryRemarks: Yup.string().required("Required"),

      decision: Yup.string().required("Required"),
      nocApprovalLetter: Yup.string().when("decision", {
        is: (decision) => !!decision,
        then: (schema) =>
          schema.required("NOC/Approval Letter is required").test("is-pdf", "File must be a valid PDF", (value) => {
            if (!value) return false;
            return typeof value === "string" && (value.endsWith(".pdf") || value.includes("pdf"));
          }),
        otherwise: (schema) => schema.notRequired(),
      }),

      remarks: Yup.string().when("decision", {
        is: (decision) => !!decision,
        then: (schema) => schema.required("Required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),

    onSubmit: async (values) => {
      setSubmitting(true);
      try {
        let endpoint = "saveVerification";
        // if (values.decision === "Approve") {
        //     endpoint = "approveStudentTransfer";
        // } else if (values.decision === "Issue NOC") {
        //     endpoint = "issueAdmissionNOC";
        // } else {
        //     endpoint = "rejectStudentTransfer";
        // }
        const payload = {
          // collCode: sessionStorage.getItem("user_id"),
          // studentId: selectedStudent?.student_id || selectedStudent?.id||selectedStudent?.student_reg_no,
          applicationNo: selectedStudent?.application_no || selectedStudent?.student_reg_no,
          vacancyAvailable: values.vacancyAvailable,
          vacancyAvailableRemarks: values.vacancyAvailableRemarks,
          sameBranch: values.sameBranch,
          sameBranchRemarks: values.sameBranchRemarks,
          intakeNorms: values.inTakeNorms,
          intakeNormsRemarks: values.inTakeNormsRemarks,
          universityCompatability: values.universityCompatability,
          universityCompatabilityRemarks: values.universityCompatabilityRemarks,
          decision: values.decision,
          nocApprovalLetter: values.nocApprovalLetter,
          remarks: values.remarks,
          // collCode: sessionStorage.getItem("college_code")
        };
        const response = await CommonAxiosPost(`${config.url.STU_URL}${endpoint}`, payload);
        if (response?.data?.scode === "01") {
          successAlert2(response?.data?.sdesc || `${values.decision} submitted successfully`).then((result) => {
            if (result?.isConfirmed) {
              // console.log("User confirmed the alert, refreshing the page...");
              setShowCheckModal(false);
            }
          });
          // fetchStudents();
          // formik.resetForm();
        } else {
          failureAlert(response?.data?.sdesc || "Submission failed");
        }
      } catch (error) {
        console.error("Error submitting decision:", error);
        failureAlert("Something went wrong!");
      } finally {
        setSubmitting(false);
      }
    },
  });
  useEffect(() => {
    if (selectedStudent?.application_no || selectedStudent?.student_reg_no) {
      fetchExistingData();
    }
  }, [selectedStudent]);

  const fetchExistingData = async () => {
    const applicationNo = selectedStudent?.application_no || selectedStudent?.student_reg_no;
    if (!applicationNo) return;

    setLoading(true);
    try {
      const response = await CommonAxiosGet(`${config.url.STU_URL}getReceivingWorkFlow?application_no=${applicationNo}`);

      // Check if data exists and status is true
      if (response?.data?.status === true && response?.data?.data?.length > 0) {
        const data = response.data.data[0]; // Get first record
        setDisableFlag(true);
        formik.setValues({
          vacancyAvailable: data.vacancy_available || "",
          vacancyAvailableRemarks: data.vacancy_available_remarks || "",
          sameBranch: data.same_branch || "",
          sameBranchRemarks: data.same_branch_remarks || "",
          inTakeNorms: data.intake_norms || "", // Note: API returns 'intakeNorms'
          inTakeNormsRemarks: data.intake_norms_remarks || "",
          universityCompatability: data.university_compatability || "",
          universityCompatabilityRemarks: data.university_compatability_remarks || "",
          detentionHistory: data.detentionHistory || "",
          detentionHistoryRemarks: data.detentionHistoryRemarks || "",
          decision: data.decision || "",
          nocApprovalLetter: data?.noc_approval_letter || "",
          remarks: data.remarks || "",
        });
      } else {
        // No data found, reset form
        // setExistingData(null);
        formik.resetForm();
      }
    } catch (error) {
      console.error("Error fetching existing data:", error);
      // setExistingData(null);
    } finally {
      setLoading(false);
    }
  };
  return (
    <FormikProvider value={formik}>
      <Form id="student-receiving-form" onSubmit={formik.handleSubmit}>
        <Container fluid className="py-4">
          {/* PDF Download & Instructions */}
          {!disableflag && (
            <div className="mb-4 p-3 bg-light border-start border-success border-4 rounded">
              <p className="mb-2 text-primary fw-bold">Kindly download the NOC Letter PDF and take a printout on your official letterhead.</p>

              <div className="d-flex align-items-center gap-3 flex-wrap">
                <Button variant="success" size="sm" onClick={handleViewPdf} disabled={pdfLoading} className="shadow-sm">
                  <FaFilePdf className="me-1" />
                  {pdfLoading ? "Loading..." : "Please Click here to download the NOC Letter"}
                </Button>

                <span className="text-muted">
                  <strong className="text-danger">Note:</strong> Upload NOC/Approval Letter and provide remarks based on the verification checklist before making the final decision.
                </span>
              </div>
            </div>)}
          {/* Final Decision */}
          <h5 className="mb-3 innerheader-new mt-4">Verification Checklist</h5>

          <VerificationChecklistTable particularsList={particularsList} formik={formik} disabled={disableflag} />

          {/* Final Decision */}
          <h5 className="mb-3 mt-4">Final Decision</h5>
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label className="st-label">
                  {" "}
                  Decision <span className="text-danger">*</span>{" "}
                </Form.Label>
                <Form.Select
                  name="decision"
                  value={formik.values.decision}
                  onChange={(e) => {
                    formik.handleChange(e);
                    if (e.target.value !== "Reject") formik.setFieldValue("remarks", "");
                  }}
                  onBlur={formik.handleBlur}
                  className="mb-2"
                  disabled={disableflag}
                >
                  <option value="">-- Select Decision --</option>
                  <option value="Approve">Approve</option>
                  {/* <option value="Issue NOC">Issue Admission NOC</option> */}
                  <option value="Reject">Reject</option>
                </Form.Select>
                <ErrorMessage name="decision" component="div" className="text-danger" />
                {formik.values.decision === "Approve" && <Form.Text className="text-success">Application will be approved.</Form.Text>}
                {/* {formik.values.decision === 'Issue NOC' && <Form.Text className="text-info">Admission NOC will be issued to the student.</Form.Text>} */}
              </Form.Group>
            </Col>

            {formik.values.decision !== "" && (
              <>
                <Col xs={12} md={6} lg={4}>
                  <Form.Label className="st-label">
                    Upload NOC/Approval Letter
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <div className="d-flex align-items-center gap-2">
                    <input
                      type="file"
                      name="nocApprovalLetter"
                      className="form-control st-control"
                      accept=".pdf"
                      disabled={disableflag}
                      onChange={(event) => {
                        const filename = "nocApprovalLetter";
                        const path = "/Uploads/StudentTransfer/";
                        ImagePdfBucket(event, formik, path, "nocApprovalLetter", filename, "pdf").then((uploadedPath) => {
                          formik.setFieldValue("nocApprovalLetter", uploadedPath || "");
                        });
                      }}
                    />
                    {formik.values.nocApprovalLetter && (
                      <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => viewImage(formik.values.nocApprovalLetter)}>
                        <FaEye />
                      </button>
                    )}
                  </div>
                  <ErrorMessage name="nocApprovalLetter" component="div" className="text-danger extra-small mt-1" />
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="st-label">
                      {" "}
                      Remarks <span className="text-danger">*</span>{" "}
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      name="remarks"
                      rows={3}
                      placeholder="Please provide detailed reason"
                      disabled={disableflag}
                      value={formik.values.remarks}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <ErrorMessage name="remarks" component="div" className="text-danger" />
                  </Form.Group>
                </Col>
              </>
            )}
          </Row>
        </Container>
      </Form>
    </FormikProvider>
  );
}
